export default __webpack_public_path__ + "static/bg-871592e457512e850cc39966b7678fcc.png";